import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCombobox, {
    attrs: {
      "disabled": _vm.disabled,
      "label": _vm.tagLabel || _vm.$i18n_t('Common.tags'),
      "items": _vm.tagItems,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "multiple": "",
      "chips": "",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.process();
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function ({
        attrs,
        item
      }) {
        return [_c(VChip, _vm._b({
          attrs: {
            "close": ""
          },
          on: {
            "click:close": function ($event) {
              return _vm.remove(item);
            }
          }
        }, 'v-chip', attrs, false), [_vm._v("\n      " + _vm._s(item) + "\n    ")])];
      }
    }]),
    model: {
      value: _vm.lclObject,
      callback: function ($$v) {
        _vm.lclObject = $$v;
      },
      expression: "lclObject"
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };